<template>
  <div class="row wrapper">
    <div class="col-11">
      <div class="integration-section">
        <img :src="computedLogoSrc"/>
      </div>
      <div class="integration-section">
        <p>
          {{ $t(`ui.integrations.${label}`) }}
        </p>
      </div>
      <div class="integration-section">
        <slot/>
      </div>
    </div>
    <div class="col-1 switch">
      <form-switch
        label="empty"
        :value="value"
        @input="updateActive"
        ref="switch"
      />
    </div>
  </div>
</template>
<script>
import FormSwitch from '@/components/helpers/DataInput/FormSwitch'

export default {
  components: {
    FormSwitch
  },
  props: {
    logoSrc: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: Boolean
    }
  },
  computed: {
    computedLogoSrc() {
      return require(`@/assets/${this.logoSrc}.svg`)
    },
  },
  methods: {
    updateActive(val) {
      if (val != this.value) {
        this.$emit('input', val)
      }
    }
  },
}
</script>
<style lang="sass" scoped>
.switch
  display: flex
  flex-direction: column
  justify-content: center
  align-items: flex-end

.wrapper
  border: 1px solid #9495984d
  border-radius: 4px
  padding: 25px 35px

.integration-section
  margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// Integration.vue?64fcc915